import * as THREE from "three";

export const BOARD_SIZE = 8;
export const SQUARE_COUNT = 64;
export const TILE_SIZE = 1;

export interface RowCol {
  row: number;
  col: number;
}

/** Matches the row-major mapping used by `coin.problems.knights_tour` on the backend. */
export function squareToRowCol(square: number): RowCol {
  if (!Number.isInteger(square) || square < 0 || square >= SQUARE_COUNT) {
    throw new RangeError(`square must be an integer in 0..${SQUARE_COUNT - 1}, got ${square}`);
  }
  return { row: Math.floor(square / BOARD_SIZE), col: square % BOARD_SIZE };
}

/** World-space center of a square's tile, board centered on the origin. */
export function squareToWorld(square: number, y = 0): THREE.Vector3 {
  const { row, col } = squareToRowCol(square);
  const x = (col - (BOARD_SIZE - 1) / 2) * TILE_SIZE;
  const z = (row - (BOARD_SIZE - 1) / 2) * TILE_SIZE;
  return new THREE.Vector3(x, y, z);
}
